<section class="rewash-settings" aria-labelledby="rewash-settings-title">
  <div class="rewash-settings__loading" *ngIf="isLoading">Loading rewash settings...</div>

  <ng-container *ngIf="!isLoading">
    <h4 id="rewash-settings-title" class="rewash-settings__title">Rewash</h4>

    <div class="rewash-settings__window-section">
      <p class="rewash-settings__subtitle">Window</p>

      <div class="rewash-settings__options">
        <label class="rewash-settings__option">
          <input
            type="radio"
            name="rewashWindowMode"
            class="rewash-settings__radio"
            [checked]="selectedMode === 'custom'"
            [disabled]="isInteractionDisabled"
            (change)="onCustomSelected()"
          />
          <span class="rewash-settings__option-label">Custom</span>
        </label>

        <label class="rewash-settings__option">
          <input
            type="radio"
            name="rewashWindowMode"
            class="rewash-settings__radio"
            [checked]="selectedMode === 'never'"
            [disabled]="isInteractionDisabled"
            (change)="onNeverSelected()"
          />
          <span class="rewash-settings__option-label">Never</span>
        </label>
      </div>
    </div>

    <div #customPanel class="rewash-settings__custom-panel" *ngIf="showCustomPanel">
      <label class="rewash-settings__time-label" for="rewashCustomMinutes">Time (in min)</label>
      <div class="rewash-settings__custom-row">
        <input
          #customMinutesInput
          id="rewashCustomMinutes"
          type="number"
          class="rewash-settings__time-input"
          [(ngModel)]="customMinutesDraft"
          (ngModelChange)="onCustomMinutesDraftChange()"
          [min]="minMinutes"
          [max]="maxMinutes"
          step="1"
          inputmode="numeric"
          [disabled]="isInteractionDisabled"
          [attr.aria-invalid]="customError ? 'true' : null"
        />
        <button
          type="button"
          class="rewash-settings__save-btn"
          [disabled]="isCustomSaveDisabled"
          (click)="onCustomSave()"
        >
          <span *ngIf="!isSavingCustom">Save</span>
          <span *ngIf="isSavingCustom">Saving...</span>
        </button>
      </div>
      <p class="rewash-settings__error" *ngIf="customError">{{ customError }}</p>
    </div>
  </ng-container>
</section>
